"use client";

import type {
  GetThoughtsRequest,
  SelectedThought,
  Thought,
} from "@/generated/fastapi";
import { THOUGHT_QUERY_DEFAULTS } from "@/features/thoughts/config/thoughtQueryScopes";
import type { SelectedThoughtDocument } from "../types";

export interface GetSelectedThoughtDocumentsRequest {
  selectedThoughts: SelectedThought[];
}

export function buildGetSelectedThoughtDocumentsRequest(
  request: GetSelectedThoughtDocumentsRequest,
): GetThoughtsRequest {
  const selectedIds = Array.from(
    new Set(
      request.selectedThoughts.flatMap((selection) => selection.thoughts_ids),
    ),
  );

  return {
    selected_ids: selectedIds,
    select_by_confirmation_status: THOUGHT_QUERY_DEFAULTS.confirmationStatus,
  };
}

export function mapThoughtToSelectedThoughtDocument(
  thought: Thought,
): SelectedThoughtDocument {
  return {
    objectID: thought.id,
    mindstring: thought.mindstring,
    prototype: thought.prototype,
    situation_id: thought.situation_id ?? null,
  };
}
